import { Seo } from '@/components/seo/Seo'
import { ButtonLink } from '@/components/ui/Button'

export function NotFoundPage() {
  return (
    <>
      <Seo path="/404" />
      <section className="mx-auto max-w-3xl px-6 py-16 sm:px-10 sm:py-24">
        <p className="eyebrow">Error 404</p>
        <h1 className="mt-4 font-display text-display-3 font-extrabold text-ink-deep">
          We couldn&rsquo;t find that page.
        </h1>
        <p className="mt-4 max-w-prose text-base leading-relaxed text-ink-slate sm:text-lg">
          The link may be out of date, or the page may have moved. Everything
          about our work starts from the home page.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <ButtonLink href="/" variant="primary" size="lg">
            Go to the home page
          </ButtonLink>
          <ButtonLink href="/#contact" variant="secondary" size="lg">
            Contact us
          </ButtonLink>
        </div>
      </section>
    </>
  )
}
